import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from '@mui/material';
import { ellipsis } from '../util/StringUtil';
export const AutoEllipsis = (props) => {
    const { maxLength, text } = props;
    if (!text || text.length < maxLength) {
        return _jsx("span", { children: text });
    }
    return (_jsx(Tooltip, { title: text, children: _jsx("span", { children: ellipsis(text, maxLength) }) }));
};
